//client/src/hooks/useSegmentos.js
import { useQuery } from '@tanstack/react-query';
import apiClient from '../services/api';

const SEGMENTOS_QUERY_KEY = 'segmentos';

const fetchSegmentos = async () => {
    const { data } = await apiClient.get('/segmentos');
    return data.data;
};

export const useSegmentos = () => {
    return useQuery({
        queryKey: [SEGMENTOS_QUERY_KEY],
        queryFn: fetchSegmentos,
        staleTime: 1000 * 60 * 5, // Cache de 5 minutos
    });
};